import React, { useState } from "react";
import { Heart } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export const LikeButton = ({ reportId, initialLiked = false, initialCount = 0 }) => {
  const { user } = useAuth();
  const [liked, setLiked] = useState(initialLiked);
  const [count, setCount] = useState(initialCount);
  const [busy, setBusy] = useState(false);

  const toggle = async (e) => {
    e?.stopPropagation?.();
    if (!user) { toast("Sign in to like decodes"); return; }
    setBusy(true);
    try {
      const r = await api.post(`/reports/${reportId}/like`);
      setLiked(r.data.liked);
      setCount(r.data.likes);
    } catch (err) { /* ignore */ } finally { setBusy(false); }
  };

  return (
    <button
      onClick={toggle}
      disabled={busy}
      data-testid={`like-button-${reportId}`}
      aria-pressed={liked}
      className={`flex items-center gap-1.5 text-sm rounded-full px-2 py-1 transition-colors ${liked ? "green-text" : "text-[var(--bone-faint)] hover:text-[var(--bone-muted)]"}`}
    >
      <Heart className={`w-4 h-4 ${liked ? "fill-current" : ""}`} />
      <span data-testid={`like-count-${reportId}`}>{count}</span>
    </button>
  );
};

export default LikeButton;
